export type DeepReadonly<T> =
  T extends Array<infer U>
    ? ReadonlyArray<DeepReadonly<U>>
    : T extends object
      ? { readonly [K in keyof T]: DeepReadonly<T[K]> }
      : T

export type DeepMutable<T> =
  T extends ReadonlyArray<infer U>
    ? Array<DeepMutable<U>>
    : T extends object
      ? { -readonly [K in keyof T]: DeepMutable<T[K]> }
      : T

// eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- 破壊的関数を置き換える際に DeepReadonly を導入したが、既存のコード全てを DeepReadonly にするのは大変なため、必要に応じて toMutable を使って DeepReadonly を DeepMutable に変換する。将来的には全ての関数を非破壊関数に置き換えて DeepReadonly を使わなくて良い状態にすることを目指す。
export const toMutable = <T>(object: DeepReadonly<T>): DeepMutable<T> => object as DeepMutable<T>
